import type { MonthStatus } from "../api";
import { STATUS_HINT, STATUS_LABEL } from "./format";

/** A month's state, in words: colour alone never carries it. */
export function StatusPill({ status }: { status: MonthStatus }) {
  return (
    <span className={`pill rev-${status}`} title={STATUS_HINT[status]}>
      {STATUS_LABEL[status]}
    </span>
  );
}
